// require('./ziggy');

window._ = require('lodash');
window.Noty = require('noty');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
window.$ = window.jQuery = require('jquery');

/*require('bootstrap-sass');*/
require('select2');

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

/*// import Echo from "laravel-echo"*/

/*window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'your-pusher-key'
});*/


window.Vue   = require('vue');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/vnd.Aafiyat2u.v1+json';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');
let header = document.head.querySelector('meta[name="api-header"]');

window._token = token.content;

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

    $.ajaxSetup({
        headers : {
            'X-CSRF-TOKEN' : token.content,
            'Accept': 'application/vnd.Aafiyat2u.v1+json',
        }
    });

} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
